<template>
    <div class="container">
      <div class="handle-box">
        <el-input v-model="query.name" placeholder="企业名称" class="handle-input mr10"></el-input>
        <el-input v-model="query.corporation" placeholder="法人" class="handle-input mr10"></el-input>
        <el-input v-model="query.contact_name" placeholder="联系人" class="handle-input mr10"></el-input>
        <el-input v-model="query.contact_phone" placeholder="联系电话" class="handle-input mr10"></el-input>
        <el-select v-model="query.is_validate" clearable placeholder="是否有效" class="handle-select mr10">
          <el-option key="1" label="有效" value="1"></el-option>
          <el-option key="2" label="无效" value="0"></el-option>
        </el-select>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
        <el-button type="primary" icon="el-icon-plus" @click="handleAdd">添加</el-button>
      </div>
      <el-table
          :data="tableData"
          border
          class="table"
          ref="multipleTable"
          header-cell-class-name="table-header"
          :cell-style="centerStyle"
      >
        <el-table-column prop="id" label="ID" align="center" width="55"></el-table-column>
        <el-table-column prop="name" label="企业名称" align="center">
          <template #default="scope">
            <el-button type="text"
                       @click="showDetail(scope.row)">
              {{ scope.row.name }}
            </el-button>
          </template>
        </el-table-column>
    
        <el-table-column prop="type" label="企业类型"  align="center" width="100">
          <template #default="scope">
            {{ companyTypeMap.get(scope.row.type) }}
          </template>
        </el-table-column>
        <el-table-column prop="credit_code" label="统一社会信用代码" align="center" width="200"></el-table-column>
        <el-table-column label="营业执照" align="center"  header-align="center" prop="license">
          <template #default="scope">
            <el-image
                class="table-td-thumb"
                :src="scope.row.license"
                :preview-src-list="[scope.row.license]"
                :hide-on-click-modal="true"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="corporation" label="法人" align="center" width="100"></el-table-column>
        <el-table-column prop="contact_name" label="联系人" align="center" width="100"></el-table-column>
        <el-table-column prop="contact_phone" label="联系电话" width="130" align="center"></el-table-column>
        <el-table-column label="是否有效" width="100" align="center">
          <template #default="scope">
            <el-button type="text" :style="'color:'+[!scope.row.is_validate?'red':'']"
                       @click="setIsvalidate(scope.$index, scope.row.id, !scope.row.is_validate)">
              {{ scope.row.is_validate ? "有效" : "无效" }}
            </el-button>
          </template>
        </el-table-column>
    <!--    <el-table-column prop="note" label="备注" width="120" align="center"></el-table-column>-->
        <el-table-column label="操作" width="120" header-align="center">
          <template #default="scope">
            <el-dropdown class="user-name" trigger="hover">
              <span class="el-dropdown-link">
                <i class="el-icon-setting"></i>
              </span>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item icon="el-icon-edit"
                  @click="handleEdit(scope.$index, scope.row)">编辑</el-dropdown-item>
                  <el-dropdown-item icon="el-icon-user-solid" @click="getStaff(scope.row)">员工管理</el-dropdown-item>
                  <!-- <el-dropdown-item icon="el-icon-s-custom" @click="handleType(scope.row)">类型</el-dropdown-item> -->
                  <el-dropdown-item icon="el-icon-link" @click="bindFranchisee(scope.row)"
                  v-if="scope.row.type === 2">分配加盟商</el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
            background
            layout="total, prev, pager, next"
            :current-page="query.page"
            :page-size="query.page_size"
            :total="pageTotal"
            @current-change="handlePageChange"
        ></el-pagination>
      </div>
    <!-- 编辑弹唱 -->
      <el-dialog :title="code ? '添加' : '编辑'" v-model="companyVisible" width="60%">
        <el-form ref="form" :model="form" class="el-dialog__body" label-width="180px" :rules="companyRules">
          <el-form-item label="企业名称" prop="name">
            <el-input v-model="form.name" class="w400"></el-input>
          </el-form-item>
          <el-form-item label="统一社会信用代码" prop="credit_code">
            <el-input v-model="form.credit_code" class="w200"></el-input>
          </el-form-item>
          <el-form-item label="营业执照">
            <Upload @newImage='getNewImage' :value="form.license" imgName="license" v-if="form.license!==null"></Upload>
          </el-form-item>
          <el-form-item label="法人" prop="corporation">
            <el-input v-model="form.corporation" class="w120"></el-input>
          </el-form-item>
          <el-form-item label="法人身份证正反面">
            <el-alert title="建议尺寸450（宽）*300（长）" type="success" style="margin-bottom: 10px;"/>
            <div class="identity">
              <Upload @newImage='getNewImage' :value="form.identity_card_front"  imgName="identity_card_front" v-if="form.identity_card_front!==null"></Upload>
            </div>
            <div class="identity">
              <Upload @newImage='getNewImage' :value="form.identity_card_back"   imgName="identity_card_back"  v-if="form.identity_card_back!==null"></Upload>
            </div>
          </el-form-item>
          <el-form-item label="联系人" prop="contact_name">
            <el-input v-model="form.contact_name" class="w120"></el-input>
          </el-form-item>
          <el-form-item label="联系电话" prop="contact_phone">
            <el-input v-model="form.contact_phone" class="w200"></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input type="textarea" v-model="form.note" class="w80" maxlength="500" show-word-limit rows="10" resize="none"></el-input>
          </el-form-item>
        </el-form>
        <template #footer>
                    <span class="dialog-footer">
                        <el-button @click="companyVisible = false">取 消</el-button>
                        <el-button type="primary" @click="saveEdit">确 定</el-button>
                    </span>
        </template>
      </el-dialog>
    <!--  添加员工弹窗-->
      <el-dialog title="添加员工" v-model="staffVisible" width="25%">
        <el-form ref="form" :model="staffForm" label-width="130px">
          <el-form-item label="姓名" required>
            <el-input v-model="staffForm.name"></el-input>
          </el-form-item>
          <el-form-item label="手机号" required>
            <el-input v-model="staffForm.phone"></el-input>
          </el-form-item>
          <el-form-item  label="角色" required>
            <el-select v-model="staffForm.role_id" placeholder="请选择">
              <el-option
                  v-for="item in roleList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <template #footer>
                    <span class="dialog-footer">
                        <el-button @click="staffVisible = false">取 消</el-button>
                        <el-button type="primary" @click="addStaffEdit">确 定</el-button>
                    </span>
        </template>
      </el-dialog>
    <!--  企业详情弹窗-->
      <el-dialog title="企业详情" v-model="detailVisible" width="60%">
        <div class="detail_box">
          <div class="box_top">
            <div class="box_left">
              <el-form>
                <el-form-item label="企业名称:">{{companyDetail.name}}</el-form-item>
                <el-form-item label="企业类型:">
                  {{ companyTypeMap.get(companyDetail.type) }}
                </el-form-item>
                <el-form-item label="统一社会信用代码:">{{companyDetail.credit_code}}</el-form-item>
              </el-form>
            </div>
            <div class="box_right">
              <el-image :src="companyDetail.license"></el-image>
              <p>（营业执照）</p>
            </div>
          </div>
          <div class="box_bottom">
            <el-form>
              <el-form-item label="法人:">{{companyDetail.corporation}}</el-form-item>
              <div>
                <div class="image">
                  <el-image :src="companyDetail.identity_card_front">
                  </el-image>
                  <p>（法人身份证正面照）</p>
                </div>
                <div class="image">
                  <el-image :src="companyDetail.identity_card_back">
                  </el-image>
                  <p>（法人身份证反面照）</p>
                </div>
              </div>
              <el-form-item label="联系人:">{{companyDetail.contact_name}}</el-form-item>
              <el-form-item label="联系电话:">{{companyDetail.contact_phone}}</el-form-item>
              <el-form-item label="是否有效:">{{companyDetail.is_validate ? '有效' : '无效'}}</el-form-item>
              <el-form-item label="备注:">{{companyDetail.note}}</el-form-item>
              <el-form-item label="录入时间:">{{ForMatHMS(companyDetail.c_at)}}</el-form-item>
            </el-form>
          </div>
        </div>
      </el-dialog>
    <!--  企业员工弹窗-->
      <el-dialog  title="员工" v-model="staffDialog" width="60%">
        <el-button
            type="primary"
            icon="el-icon-plus"
            @click="addStaff()"
            class="mb10"
        >添加员工
        </el-button>
        <el-table
            :data="staffData"
            border
            class="table"
            ref="multipleTable"
            header-cell-class-name="table-header"
            :cell-style="centerStyle"
        >
          <el-table-column prop="id" label="ID" align="center" width="55"></el-table-column>
          <el-table-column prop="name" label="姓名" align="center"></el-table-column>
          <el-table-column prop="role_name" label="角色" align="center"></el-table-column>
          <el-table-column prop="phone" label="手机号" align="center"></el-table-column>
          <el-table-column prop="is_validate" label="是否有效" align="center">
            <template #default="scope">
              {{scope.row.is_validate ? '有效' : '无效'}}
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination
              background
              layout="total, prev, pager, next"
              :current-page="staff_query.page"
              :page-size="staff_query.page_size"
              :total="staffPageTotal"
              @current-change="handleStaffPageChange"
          ></el-pagination>
        </div>
      </el-dialog>
    <!--  分配加盟商-->
      <el-dialog  title="分配加盟商" v-model="bindDialog" width="60%">
                <el-transfer
                    v-model="checkedFranchisee"
                    style="text-align: left; display: inline-block"
                    :render-content="renderFunc"
                    filterable
                    :titles="['所有加盟商', '已绑定的加盟商']"
                    :format="{
                noChecked: '${total}',
                hasChecked: '${checked}/${total}',
              }"
                    :data="franchiseeList"
                >
                </el-transfer>
              <template #footer>
              <span class="dialog-footer">
                     <el-button @click="bindDialog = false">取 消</el-button>
                     <el-button type="primary" @click="saveFranchisee">确 定</el-button>
              </span>
              </template>
      </el-dialog>
      <el-dialog title="修改类型" v-model="editTypeVisible" width="25%">
        <el-form ref="form" label-width="70px">
          <el-form-item  label="角色" required>
            <el-select v-model="type" placeholder="请选择">
              <el-option
                  v-for="item in typeMap"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
            <el-tooltip class="item" effect="dark" content="修改类型之后请在商户后台管理系统对所有员工重新设置身份" placement="top-start">
            <el-button class="el-button-problem" icon="el-icon-warning-outline" type="text"></el-button>
          </el-tooltip>
          </el-form-item>
        </el-form>
        <template #footer>
                    <span class="dialog-footer">
                        <el-button @click="editTypeVisible = false">取 消</el-button>
                        <el-button type="primary" @click="saveType()">确 定</el-button>
                    </span>
        </template>
      </el-dialog>
    </div>
    </template>
    
    <script>
    import moment from "moment";
    import {
      addCompanyStaff,
      getAgentFranchisee,
      getCompanyDeatil,
      getCompanyList,
      getCompanyOptions, getCompanyRole,
      getCompanyStaff,
      saveCompany, setAgentFranchisee,
      setCompanyIsValidate, setCompanyType
    } from "@/api/company";
    import Upload from "@/components/Upload.vue";
    import {ElOption, ElPagination, ElTableColumn, ElTooltip} from "element-plus";
    
    export default {
      name: "AgentTable",
      components: {ElTooltip, ElOption, ElPagination, ElTableColumn, Upload},
      data(){
        return{
          action: 'https://wx.yixiankeji.com/admin/upload',
          query:{
            name:'',
            type:2,
            license:null,
            credit_code:"",
            corporation:'',
            identity_card_front:'',
            identity_card_back:'',
            contact_name:'',
            contact_phone:'',
            is_validate:'',
            note:'',
            page:1,
            page_size:10
          },
          form:{
            id:null,
            name:'',
            license:null,
            credit_code:"",
            corporation:'',
            identity_card_front:'',
            identity_card_back:'',
            contact_name:'',
            contact_phone:'',
            is_validate:'',
            note:'',
            type:2
          },
          tableData:[],
          pageTotal:0,
          companyType:[],
          companyTypeMap:new Map(),
          code:true,
          companyVisible:false,
          companyRules: {
            name: [{required: true, message: '请输入企业名称', trigger: 'blur'}],
            type: [{required: true, message: '请输入企业类型', trigger: 'blur'}],
            contact_name: [{required: true, message: '请输入联系人', trigger: 'blur'}],
            contact_phone: [
              {required: true, message: '请输入联系电话', trigger: 'blur'},
              {min:11,max:11, message: '请输入正确的联系电话', trigger: 'blur'}
            ],
            credit_code:[
                {max:18, message: '最多输入18位', trigger: 'blur'},
                {required: true, message: '请输入统一社会信用代码', trigger: 'blur'}
            ],
          },
          staffForm:{
            company_id:null,
            name:'',
            phone:'',
            role_id:null
          },
          staffVisible:false,
          companyDetail:{},
          detailVisible:false,
          staffData:[],
          staff_query:{
            company_id:null,
            page: 1,
            page_size: 10
          },
          staffDialog:false,
          staffPageTotal:0,
          bindDialog:false,
          checkedFranchisee:[],
          franchiseeList:[],
          typeMap:[
            {
              value:1,
              label:'加盟商'
            },
            {
              value:2,
              label:'代理商'
            }
          ],
          franchisee_query:{
            id:null,
            ids:''
          },
          roleList:[],
          editTypeVisible:false,
          type:null,
          typeOptions:[],
          roleForm:{}
        }
      },
      created() {
        this.getData()
        this.getCompanyType()
      },
      methods:{
        renderFunc(h, option) {
          return <span title={option.label}>{option.label}</span>;
        },
        tabClick(){
          this.query.page = 1
          this.getData()
        },
        centerStyle(){
          return 'text-align:center'
        },
        getNewImage(e){
          for(let key in this.form){
            if (key === e.imgName){
              this.form[key] = e.imgUrl
            }
          }
        },
        getData(){
          getCompanyList(this.query).then(res=>{
            this.tableData = res.data
            if (this.query.page === 1) {
              this.pageTotal = res.count
            }
          })
        },
        ForMatHMS(date) {
          return moment(parseInt(date + "000")).format("YYYY-MM-DD HH:mm:ss")
        },
        getCompanyType(){
          let that = this
          getCompanyOptions().then(res=>{
            res.forEach(function (item) {
              that.companyTypeMap.set(item.value, item.label)
            })
            this.companyType = res
          })
        },// 分页导航
        handlePageChange(val) {
          this.query.page = val
          this.getData()
        },
        dateFormat: function (row, column) {
          const date = row[column.property];
          if (date === undefined) {
            return "";
          }
          return moment(parseInt(date + "000")).format("YYYY-MM-DD")
        },
      //   搜索
        handleSearch(){
          this.query.page = 1
          this.getData()
        },
        handleEdit(index,row){
          this.code = false
          getCompanyDeatil(row.id).then(res=>{
            this.form = JSON.parse(JSON.stringify(res))
            this.form.id = row.id
            this.form.license = res.license
            this.form.identity_card_front = res.identity_card_front
            this.form.identity_card_back = res.identity_card_back
          })
          this.companyVisible = true
        },
        handleAdd(){
          this.code = true
          this.form = {}
          this.form.license = ''
          this.form.identity_card_front = ''
          this.form.identity_card_back = ''
          this.companyVisible = true
        },
        saveEdit(){
          this.form.type = this.query.type
          saveCompany(this.form,this.form.id).then(res=>{
              if (res) {
                this.$message.success('保存成功')
                this.companyVisible = false
              }
              this.getData()
          })
        },
        setIsvalidate(index,id,isvalidate) {
          setCompanyIsValidate(id,isvalidate).then(res => {
            if (res === true) {
              this.$message.success('保存成功')
              this.tableData[index].is_validate = isvalidate
    
            }
          })
        },
        beforeAvatarUpload(file) {
          const isJPG = file.type === 'image/jpeg';
          const isLt2M = file.size / 1024 / 1024 < 2;
          if (!isLt2M) {
            this.$message.error('上传图片大小不能超过 2MB!');
            return
          }
          if (!isJPG) {
            this.$message.error('上传图片必须是JPG格式!');
            return
          }
          return isJPG && isLt2M;
        },
        addStaff(){
          this.staffForm = {}
          this.staffForm.company_id = this.staff_query.company_id
          this.staffVisible = true;
          this.getStaffRole()
        },
        getStaffRole(){
          getCompanyRole(this.staffForm.company_id).then(res=>{
            this.roleList = res
          })
        },
        addStaffEdit(){
          this.staffForm.company_id = Number(this.staffForm.company_id)
          addCompanyStaff(this.staffForm.company_id,this.staffForm).then(res => {
            if (res) {
              this.$message.success('添加成功')
              this.staffVisible = false;
              this.getStaff(this.staff_query)
            }
          })
        },
      //展示详情
        showDetail(row){
          this.detailVisible = true
          getCompanyDeatil(row.id).then(res=>{
            this.companyDetail = JSON.parse(JSON.stringify(res))
          })
        },
      //获取企业员工
        getStaff(row){
          this.staff_query.page = 1
          this.staff_query.company_id = row.id ? row.id.toString() : this.staff_query.company_id
          this.staffDialog = true
          getCompanyStaff(this.staff_query).then(res=>{
            this.staffData = res.data
            if(this.staff_query.page === 1){
              this.staffPageTotal = res.count
            }
          })
        },
        handleStaffPageChange(val){
          this.staff_query.page = val
          this.getStaff()
        },
        //  分配加盟商
        bindFranchisee(row){
          this.franchisee_query.id = row.id
          this.getAllFranchisee()
          this.bindDialog = true
          this.checkedFranchisee = []
          this.query.type = 2
          getAgentFranchisee(row.id).then(res=>{
            res.forEach(item=>{
              this.checkedFranchisee.push(item.id)
            })
          })
        },
        // 获取所有的加盟商
        getAllFranchisee(){
          this.query.type = 1
          this.franchiseeList = []
          getCompanyList(this.query).then(res=>{
            res.data.forEach(item=>{
              this.franchiseeList.push(
                  {
                    key:item.id,
                    label:item.name,
                    disabled:false
                  }
              )
            })
          })
        },
        // 分配加盟商
        saveFranchisee(){
          this.franchisee_query.ids = this.checkedFranchisee.toString()
          setAgentFranchisee(this.franchisee_query.id,this.franchisee_query).then(res=>{
            if(res === true){
              this.$message.success('添加成功')
              this.bindDialog = false
            }
          })
        },
      //   修改商户类型
        handleType(row){
          this.type = this.query.type
          this.editTypeVisible = true
          this.roleForm.id = row.id
        },
        saveType(){
          setCompanyType(this.roleForm.id,this.type).then(res=>{
            if(res){
              this.$message.success('修改成功')
              this.editTypeVisible = false
              this.getData()
            }
          })
        },
      }
    }
    </script>
    
    <style scoped>
    .select{
      margin-bottom: 10px;
    }
    .handle-box{
      margin-bottom: 10px;
    }
    .avatar {
      height: 180px;
      display: block;
    }
    
    .handle-input {
      width: 200px;
      display: inline-block;
    }
    
    .mr10 {
       margin-right: 10px;
     }
    .el-select{
      width: 120px;
    }
    .el-dialog__body{
      height: 50vh;
      overflow: auto;
    }
    
    .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    
    .avatar-uploader .el-upload:hover {
      border-color: #409EFF;
    }
    
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 178px;
      height: 178px;
      line-height: 178px;
      text-align: center;
    }
    
    .avatar {
      height: 178px;
      display: block;
    }
    .table-td-thumb {
      display: block;
      margin: auto;
      width: 40px;
      height: 40px;
    }
    .w400{
      width: 400px;
    }
    .w200{
      width: 200px;
    }
    .w120{
      width: 120px;
    }
    .identity{
      float: left;
      margin-right: 30px;
    }
    
    .detail_box{
      width: 90%;
      margin: 0 auto;
      height: 65vh;
      overflow-x: hidden;
    }
    .detail_box p{
      text-align: center;
      margin-bottom: 10px;
    }
    .box_left{
      padding-top: 50px;
      width: 50%;
      float: left;
      box-sizing: border-box;
    }
    .image{
      width: 40%;
      display: inline-block;
      margin-right: 5%;
      text-align: center;
    }
    .box_top{
      height: 210px;
    }
    .box_top .el-form-item{
      height: 40px;
    }
    .box_right{
      height: 100%;
      width: 40%;
      display: inline-block;
      text-align: center;
    }
    .box_right .el-image{
      height: 180px;
    }
    .box_bottom{
      margin-top: 30px;
    }
    .box_bottom .el-image{
      height: 180px;
      margin: 0 auto;
      margin-bottom: 20px;
    }
    .w80{
      width: 80%;
    }
    /deep/.el-transfer-panel{
      width: 35%;
    }
    .mb10{
      margin-bottom: 10px;
    }
    .el-button-problem{
      font-size: 20px;
      margin-left: 10px;
    }
    </style>